import { Injectable } from "@nestjs/common";
import { AdminApprovalreq, AssignVendor, CommonResponseModel, DriverUpdateReq, MessageParameters, TripReq, VehicleEmailModel, VehicleIdReq, VehicleIssueStatusenum, VehicleRequest, VehicleStatus, VehicleStatusenum, VehicleTypeReq, VehicletypeEnum, roleReq } from "@project-management-system/shared-models";
import { VehicleRequestEntity } from "./vehicle-req-entity";
import { VehicleReqDto } from '../../../../../../../libs/shared-models/src/common/vms/vehicle-req/vehicle-req-dto'
import {vehicleReportReq} from '../../../../../../../libs/shared-models/src/common/vms/vehicle-req/vehicle-report-req'
import { InjectRepository } from "@nestjs/typeorm";
import { In, Repository } from "typeorm";
import { VehicleReqRepo } from "./vehicle-req-repo";
import {WhatsAppNotificationService} from '../../../../../../../libs/shared-services/src/notification-management/whatsapp-notification-service'
import WhatsAppInfo from "packages/libs/shared-services/src/whatsapp-info";
import moment = require("moment");
import { VehicleEntity } from "../vehicle/vehicle.entity";
import { DatesDto } from "./dto/dates.dto";
import { VehicleTypeReq as vehReq } from "../vehicle/vehicle-type.req";
import { VehicleReqId } from "./dto/vehicle-req-id";
import { throwError } from "rxjs";
import { EmployeeRepo } from "../employee/employee.repo";
import axios from "axios";
import { VendorEntity } from "../vendor/vendor.entity";
import { EmailService } from "@project-management-system/shared-services";
@Injectable()
export class VehicleReqService {
    constructor(
        @InjectRepository(VehicleRequestEntity)
        private vehiclereqrepo: Repository<VehicleRequestEntity>,
        // @InjectRepository(VehicleRequestEntity)
        private vehiclereqRepo:VehicleReqRepo,
        private employeeRepo:EmployeeRepo,

        private whatsAppService:WhatsAppNotificationService,
        @InjectRepository(VehicleEntity)
        private vehiclerepo: Repository<VehicleEntity>,
        private mailService : EmailService

    ) { }
    async getMaxId(): Promise<any> {
        const query = this.vehiclereqrepo.createQueryBuilder('v')
            .select(` MAX(id) as id `)
            .orderBy(` created_at`, 'DESC')
        return await query.getRawOne();
    }

    async getAllDetailByVehicelId(vehicleId: any): Promise<any> {
        console.log(vehicleId, 'vehicleIdvehicleId'); // Debugging
    
        // Ensure vehicleId is extracted correctly
        const vehicleIdNum = typeof vehicleId === 'object' ? Number(Object.keys(vehicleId)[0]) : Number(vehicleId);
    
        if (isNaN(vehicleIdNum) || vehicleIdNum <= 0) {
            console.error("Invalid vehicleId:", vehicleId);
            throw new Error("Invalid vehicle ID provided.");
        }
    
        // Correcting the SQL Syntax (Fixed "WHERE" typo)
        const query = `
            SELECT 
                vlr.vehicle_name AS assgnedVehicle, vehicle_required_on AS vehicleReqOn, 
                dr.name AS driverName, dr.phone_number AS driverPhnNum, 
                ven.phone_number AS vendorPhoneNumber, ven.vendor_name AS vendorName, 
                v.vehicle_id, edt.contact_number AS hodContactNum, 
                edt.employee_name AS headOfThedeprt, e.contact_number AS empContactNumber, 
                vlr.vehicle_capacity AS vehicleCapacity, e.employee_name AS employeeName, 
                vlr.registration_number AS vehicleNo, v.total_amount AS totalCost, 
                v.type, v.total_kms AS totalDistance, e.approval_head_mail AS approvalHeadMail,
                d.department_name AS departmentName, vehicle_req_code AS vehicleReqCode, 
                employee_id AS employeeId, sl.location_name AS source, 
                v.pick_up_time AS pickUpTime, vl.vehicle_category AS vehiclePreference, 
                v.vehicle_purpose AS vehiclePurpose, dl.location_name AS destination, 
                vehicle_required_on AS vehicleRequiredOn, v.vehicle_type AS vehicleType, 
                no_of_people AS noOfPeople, cost, distance, v.status, 
                department_id AS vdepartMentId, v.created_at AS requestedOn, 
                v.id AS vehiclereqId, v.created_user AS user, v.user_contact AS userContact
            FROM vehicle_request v
            LEFT JOIN employee e ON e.id = v.employee_id
            LEFT JOIN department d ON d.id = v.department_id
            LEFT JOIN vehicle_category vl ON vl.id = v.vehicle_preference
            LEFT JOIN vehicle vlr ON vlr.id = v.vehicle_id
            LEFT JOIN department ed ON ed.id = e.department_name
            LEFT JOIN employee edt ON edt.id = ed.hod_id
            LEFT JOIN vendor ven ON ven.id = v.vendor_id
            LEFT JOIN driver dr ON dr.id = v.driver_id
            LEFT JOIN locations sl ON sl.id = v.source
            LEFT JOIN locations dl ON dl.id = v.destination
            WHERE v.id = ${vehicleIdNum};
        `;
    
        console.log("Executing Query:", query); // Debugging
    
        const result = await this.vehiclereqRepo.query(query);
        return result;
    }

    async getAllDetailsofvehReq(id:number):Promise<any>{
        const query=`select vlr.vehicle_name as assgnedVehicle,vehicle_required_on as vehicleReqOn, dr.name AS driverName,dr.phone_number AS driverPhnNum,ven.phone_number AS vendorPhoneNumber,ven.vendor_name AS vendorName,v.vehicle_id,edt.contact_number AS hodContactNum,edt.employee_name AS headOfThedeprt,e.contact_number AS empContactNumber,vlr.vehicle_capacity AS vehicleCapacity, e.employee_name AS employeeName,vlr.registration_number AS vehicleNo,v.total_amount AS totalCost,v.type,v.total_kms AS totalDistance,e.approval_head_mail AS approvalHeadMail,
        d.department_name AS departmentName,vehicle_req_code AS vehicleReqCode,employee_id AS employeeId,sl.location_name AS source,v.pick_up_time as pickUpTime,vl.vehicle_category AS vehiclePreference,v.vehicle_purpose AS vehiclePurpose,
        dl.location_name AS destination,vehicle_required_on AS vehicleRequiredOn     
                   ,v.vehicle_type AS vehicleType,no_of_people AS noOfPeople,cost ,distance,v.status,department_id AS vdepartMentId,v.created_at AS requestedOn,v.id as vehiclereqId,v.created_user AS user,v.user_contact AS userContact
                          FROM vehicle_request v
                LEFT JOIN employee e ON e.id=v.employee_id
                LEFT JOIN department d ON d.id=v.department_id 
                LEFT JOIN vehicle_category vl ON vl.id=v.vehicle_preference
                LEFT JOIN vehicle vlr ON vlr.id=v.vehicle_id
                LEFT JOIN department ed ON ed.id=e.department_name
                LEFT JOIN employee edt ON edt.id=ed.hod_id
                LEFT JOIN vendor ven ON ven.id=v.vendor_id
                LEFT JOIN driver dr ON dr.id= v.driver_id
                LEFT JOIN locations sl ON sl.id= v.source
                LEFT JOIN locations dl ON dl.id= v.destination
                WHERE v.id=`+id+``
        const result = await this.vehiclereqRepo.query(query)
        return result
    }
    async createVehiclerequest(req: VehicleReqDto): Promise<CommonResponseModel> {
        try {
            let deptId = await this.employeeRepo.findOne({where:{id:req.employeeId}});
            const currentYear = new Date().getFullYear();
            const lastTwoDigitsCurrentYear = currentYear % 100;
            const lastTwoDigitsNextYear = (currentYear + 1) % 100;
            const maxIdDetails = await this.getMaxId();
            const maxId = maxIdDetails.id
            const nextId = Number(maxId) + 1
            const vehcicleReCode = 'VEHR/'+lastTwoDigitsCurrentYear+-+lastTwoDigitsNextYear+'/'+nextId.toString().padStart(3, '0');
            const entity = new VehicleRequestEntity()
            entity.vehicleReqCode = vehcicleReCode
            entity.employeeId = req.employeeId
            entity.plantId = req.plantId
            entity.source = req.source
            entity.destination = req.destination
            entity.noOfPeople = req.noOfPeople
            entity.vehicleRequiredOn = req.vehicleRequiredOn
            entity.createdUser = req.createdUser
            entity.status = VehicleStatus.HOD_APPROVAL_PENDING
            entity.vehiclePreference=req.vehiclePreference
            entity.vehiclePurpose=req.vehiclePurpose
            entity.departmentId=deptId.departmentName;
            entity.pickUpTime=req.pickUpTime
            entity.requestedFor=req.requestedFor
            entity.type=req.type
            entity.userContact=req.userContact
            const save = await this.vehiclereqRepo.save(entity)
            if(save){
                const allData = await this.getAllDetailsofvehReq(save.id)
                const hodEmail = allData[0]?.approvalHeadMail || null;
                if (!hodEmail) {
                    return new CommonResponseModel(false, 0, 'HOD Email not found, unable to send approval request');
                }
                const emailSent = await this.sendRequestMailForVehicle({
                    emailId: hodEmail,
                    id: save.id,
                    requestNo: vehcicleReCode,
                    employeeName: allData[0]?.employeeName || '-',
                    departmentName: allData[0]?.departmentName || '-',
                    source: allData[0]?.source || '-',
                    destination: allData[0]?.destination || '-',
                    noOfPeople: allData[0]?.noOfPeople || '-',
                    vehicleReqOn: moment(allData[0]?.vehicleReqOn).format('YYYY-MM-DD') || '-',
                    user: allData[0]?.user || '-',
                    userContact: allData[0]?.userContact || '-'
                });
        
                let messageContent=`Vehicle Req Alert || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source :${allData[0]?.source?allData[0].source:' '} || Destination :${allData[0]?.destination?allData[0].destination:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On :${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || Vehicle is Requested ! Please Check the Mail for Approval`
                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent }, 
                ];
             
                const contacts = WhatsAppInfo.contacts;
                // const contactDetails =["9177025362","7416360014",allData[0].hodContactNum,allData[0].empContactNumber]
                const contactDetails =["917036716813","919900064294"]
                let statusFlag
                for (const contact of contactDetails) {
                    const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
                    const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    if (!messageStatus.status) {
                        statusFlag = false
                        break

                    } else {
                        statusFlag = true
                    }

                }
                let res = await this.forwardVehicleRequestToHod(allData);
                // console.log(res);
            }
            return new CommonResponseModel(true, 1, 'Request Raised For Vehicle',save)
        } catch (err) {
            throw err
        }
    }

    private async sendRequestMailForVehicle(dto: any): Promise<boolean> {
        const dcDetails = new VehicleEmailModel();
        dcDetails.requestNo = dto.requestNo;
        dcDetails.to = dto.emailId;
        dcDetails.html = `
              <html>
              <head>
                <meta charset="UTF-8" />
                <style>
                  #acceptDcLink {
                        display: inline-block;
                        padding: 10px 20px;
                        background-color: #28a745;
                        color: #fff;
                        text-decoration: none;
                        border-radius: 5px;
                        margin-top: 10px;
                        transition: background-color 0.3s ease, color 0.3s ease;
                        cursor: pointer;
                    }
                    #acceptDcLink.accepted {
                        background-color: #6c757d;
                        cursor: not-allowed;
                    }
                    #acceptDcLink:hover {
                        background-color: #218838;
                        color: #fff;
                    }
                </style>
              </head>
              <body>
                <p>Dear team,</p>
                <p>Please find the Vehicle Request details below:</p>
                <p><strong>Vehicle Request NO:</strong> ${dto.requestNo}</p>
                <p><strong>Employee:</strong> ${dto.employeeName}</p>
                <p><strong>Department:</strong> ${dto.departmentName}</p>
                <p><strong>Source:</strong> ${dto.source}</p>
                <p><strong>Destination:</strong> ${dto.destination}</p>
                <p><strong>No of People:</strong> ${dto.noOfPeople}</p>
                <p><strong>Vehicle Required On:</strong> ${dto.vehicleReqOn}</p>
                <p><strong>User Name:</strong> ${dto.user}</p>
                <p><strong>User Contact:</strong> ${dto.userContact}</p>
                <p>Please click the link below for details:</p>
                <input type="hidden" id="dcId" value=${dto.id} />
                <a
                href="https://vrs12.schemaxtech.in/#/vehicle-email/${dto.id}"
                style="
                  display: inline-block;
                  padding: 10px 20px;
                  background-color: #108f1a;
                  color: #fff;
                  text-decoration: none;
                  border-radius: 5px;
                "
                >Accept Vehicle Request</a
              >
              <a
                href="https://vrs12.schemaxtech.in/#/vehicle-reject-mail/${dto.id}"
                style="
                  display: inline-block;
                  padding: 10px 20px;
                  background-color: #ff001e;
                  color: #fff;
                  text-decoration: none;
                  border-radius: 5px;
                "
                >Reject Vehicle Request</a
              >
              </body>
            </html>
            `;
        dcDetails.subject = 'Vehicle Request Number : ' + dto.requestNo;
      
        try {
          const res = await this.mailService.sendVehicleMail(dcDetails);
          console.log(res,'ressss')
          return res.status === 201 && res.data.status;
        } catch (error) {
          console.error('Error sending email:', error);
          return false;
        }
      }


    async getAllVehiclerequest(req:VehicleRequest): Promise<CommonResponseModel> {
       try{
        const data = await this.vehiclereqRepo.getAllVehiclerequest(req)
          if(data){
            return new CommonResponseModel(true,1,'Data rerived SucessFully',data)

          }else{
            return new CommonResponseModel(false,0,'No Data Found',[])
        }
       }catch(err){
        throw err
    }
}
        


    async getAdminApproval(req:VehicleRequest): Promise<CommonResponseModel> {
        try{
            const data = await this.vehiclereqRepo.getAdminApproval(req)
            if(data){
                return new CommonResponseModel(true,1,'Data rerived SucessFully',data)
            }else{
                return new CommonResponseModel(false,0,'No Data Found',[])
            }

        }catch(err){
            throw err
        }
   }
   


    async getAllDeptWiseVehcieReq(req:roleReq):Promise<CommonResponseModel>{
        try{
            const data = await this.vehiclereqRepo.getAllDeptWiseVehicleData(req)
            if(data){
                return new CommonResponseModel(true,1,'Data rerived SucessFully',data)
            }else{
                return new CommonResponseModel(false,0,'No Data Found',[])
            }

        }catch(err){
            throw err
        }
    }

    async updateHodApproval(req:VehicleIdReq):Promise<CommonResponseModel>{
        try{
            const getReqDetails = await this.vehiclereqRepo.findOne({where:{id:req.vehicleId}});
            const update = await this.vehiclereqRepo.update({id:req.vehicleId},{status:getReqDetails.status === VehicleStatus.HOD_APPROVAL_PENDING ?VehicleStatus.ADMIN_APPROVAL_PENDING:getReqDetails.status ,hodApprovalDate:req.hodApprovalDate})
            if(update.affected){
                const query = 'select contact_number as contactNum from employee where employee_name = "MRUTHUNJAYA.S"'
                const adminNum = await this.vehiclereqRepo.query(query)
                // console.log(adminNum,'WWWWWWWWWWWWWWWWWWWWWWWWWWWWW')
                const allData = await this.getAllDetailsofvehReq(req.vehicleId)
                // console.log(allData);
                 let messageContent=`HOD Approved || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source : ${allData[0]?.source?allData[0].source:' '} || Destination : ${allData[0]?.destination?allData[0].destination:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On : ${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || Waiting On Admin Approval`

                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent }, 
                ];
                const contactDetails =["917036716813","919900064294",allData[0].hodContactNum,allData[0].empContactNumber,adminNum[0]?.contactNum]
                let statusFlag
                for (const contact of contactDetails) {
                    const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
                //    console.log(whatsappres,'whatsappppppppp parametressssssssssssss')
                    const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    // console.log(messageStatus,'messageStatusmessageStatusmessageStatusmessageStatusmessageStatus')
                    if (!messageStatus.status) {
                        statusFlag = false
                        break

                    } else {
                        statusFlag = true
                    }

                }

                return new CommonResponseModel(true,1,'Approved Sucessfully. ',{'reqCode':getReqDetails.vehicleReqCode,'employee_contact':allData[0]?.empContactNumber,})
            }else{
                return new CommonResponseModel(false,0,'Something Went Wrong')
            }
        
        }catch(err){
            throw err
        }
    }

    async updateHODRejection(req:VehicleIdReq):Promise<CommonResponseModel>{
        try{
            const reqData =  await this.vehiclereqRepo.findOne({where:{id:req.vehicleId}});
            const update = await this.vehiclereqRepo.update({id:req.vehicleId},{status:VehicleStatus.REJECTED})
            if(update.affected){
                const query = 'select contact_number as contactNum from employee where employee_name = "MRUTHUNJAYA.S"'
                const adminNum = await this.vehiclereqRepo.query(query)
                const allData = await this.getAllDetailsofvehReq(req.vehicleId)
                console.log(allData);
                let msg
                let messageContent
                let contactDetails

                msg='Note : HOD Rejected Request'
                messageContent=`HOD Rejected || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source : ${allData[0]?.source?allData[0].source:' '} || Destination : ${allData[0]?.destination?allData[0].destination:' '} || Vehicle : ${allData[0]?.assgnedVehicle?allData[0].assgnedVehicle:' '} || Vehicle Type : '' || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On : ${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Cost : '0 rs' || Distance : '0 km' || Driver : ${allData[0]?.driverName?allData[0].driverName:' '} || Driver Contact Number : ${allData[0]?.driverPhnNum?allData[0].driverPhnNum:' '} || Vehicle Number : ${allData[0]?.vehicleNo?allData[0].vehicleNo:' '} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || ${msg} `

                contactDetails =["917036716813","919900064294",allData[0]?.hodContactNum,allData[0]?.empContactNumber,adminNum[0]?.contactNum,allData[0]?.driverPhnNum]
                
                // contactDetails =["917036716813"]
                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent }, 
                ];
                let statusFlag
                for (const contact of contactDetails) {
                    const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
                   console.log(whatsappres,'whatsappppaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
                    const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    console.log(messageStatus,'mesage statussssssssssssssssssssss')
                    if (!messageStatus.status) {
                        statusFlag = false
                        break

                    } else {
                        statusFlag = true
                    }

                }
                return new CommonResponseModel(true,1,'Admin Approved Sucessfully', {'reqCode':reqData.vehicleReqCode,'EmpContact':allData[0]?.empContactNumber,'hodContact':allData[0]?.hodContactNum})
            }else{
                return new CommonResponseModel(false,0,'Something Went Wrong')
            }
        }catch(err){
            throw err
        }
    }


    async updateAdminRejection(req:VehicleIdReq):Promise<CommonResponseModel>{
        try{
            const reqData =  await this.vehiclereqRepo.findOne({where:{id:req.vehicleId}});
            const update = await this.vehiclereqRepo.update({id:req.vehicleId},{status:VehicleStatus.REJECTED})
            if(update.affected){
                const query = 'select contact_number as contactNum from employee where employee_name = "MRUTHUNJAYA.S"'
                const adminNum = await this.vehiclereqRepo.query(query)
                const allData = await this.getAllDetailsofvehReq(req.vehicleId)
                // console.log(allData);
                let msg
                let messageContent
                let contactDetails

                msg='Note : Admin Rejected Request'
                messageContent=`Admin Approved || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source : ${allData[0]?.source?allData[0].source:' '} || Destination : ${allData[0]?.destination?allData[0].destination:' '} || Vehicle : ${allData[0]?.assgnedVehicle?allData[0].assgnedVehicle:' '} || Vehicle Type : '' || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On : ${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Cost : '0 rs' || Distance : '0 km' || Driver : ${allData[0]?.driverName?allData[0].driverName:' '} || Driver Contact Number : ${allData[0]?.driverPhnNum?allData[0].driverPhnNum:' '} || Vehicle Number : ${allData[0]?.vehicleNo?allData[0].vehicleNo:' '} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || ${msg} `

                contactDetails =["917036716813","919900064294",allData[0]?.hodContactNum,allData[0]?.empContactNumber,adminNum[0]?.contactNum,allData[0]?.driverPhnNum]

                

                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent }, 
                ];
                let statusFlag
                for (const contact of contactDetails) {
                    const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
                //    console.log(whatsappres,'whatsappppaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
                    const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    // console.log(messageStatus,'mesage statussssssssssssssssssssss')
                    if (!messageStatus.status) {
                        statusFlag = false
                        break

                    } else {
                        statusFlag = true
                    }

                }
                return new CommonResponseModel(true,1,'Admin Approved Sucessfully', {'reqCode':reqData.vehicleReqCode,'EmpContact':allData[0]?.empContactNumber,'hodContact':allData[0]?.hodContactNum})
            }else{
                return new CommonResponseModel(false,0,'Something Went Wrong')
            }
        }catch(err){
            throw err
        }
    }

    async updateAdminApproveData(req:AdminApprovalreq):Promise<CommonResponseModel>{
        try{
            const reqData =  await this.vehiclereqRepo.findOne({where:{id:req.vehicleReqId}});
            const update = await this.vehiclereqRepo.update({id:req.vehicleReqId},{adminApprovalDate:req.approvalDate,cost:req.approxCost,distance:req.approxDistance,status:req.vehicleType === VehicletypeEnum.IN_HOUSE_VEHICLE?VehicleStatus.VEHICLE_ASSIGNED:VehicleStatus.WAITING_ON_VENDOR,vehicleType:req.vehicleType,vendorId:req.vendorId,vehicleId:req.veheicleId,driverId:req.driverId,driverContact:req.driverContactNum,remarks:req.remarks,slabId:req.slabId,totalHrs:req.totalHrs,tripType:req.type,vehicleCategory:req.vehicleCategory})
            if(req.vehicleType === VehicletypeEnum.IN_HOUSE_VEHICLE){
                let updateVehicleStatus = await this.vehiclerepo.update({id:req.veheicleId},{vehicleStatus:VehicleStatusenum.OCCUPIED});
                // console.log(updateVehicleStatus)
            }
            if(update.affected){
                const query = 'select contact_number as contactNum from employee where employee_name = "MRUTHUNJAYA.S"'
                const adminNum = await this.vehiclereqRepo.query(query)
                const allData = await this.getAllDetailsofvehReq(req.vehicleReqId)
                // console.log(allData);
                let msg
                let messageContent
                let contactDetails

                if(req.vehicleType === VehicletypeEnum.VENDOR_VEHICLE){
                    msg='Note : New Request Arrived Please Assign Vehicle '
                    messageContent=`Admin Assigned To Vendor || Source : ${allData[0]?.source?allData[0].source:' '} || Destination : ${allData[0]?.destination?allData[0].destination:' '}|| Vehicle Type : ${allData[0].vehicleType?allData[0].vehicleType:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On : ${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} ||  ${msg} `

                    contactDetails =[allData[0]?.hodContactNum,allData[0]?.empContactNumber,adminNum[0]?.contactNum,allData[0]?.vendorPhoneNumber]
                }else{
                    msg='Note : Admin Assigned Vehicle'
                    messageContent=`Admin Approved || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source : ${allData[0]?.source?allData[0].source:' '} || Destination : ${allData[0]?.destination?allData[0].destination:' '} || Vehicle : ${allData[0]?.assgnedVehicle?allData[0].assgnedVehicle:' '} || Vehicle Type : ${allData[0].vehicleType?allData[0].vehicleType:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On : ${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Cost : ${allData[0].cost?allData[0].cost+' rs':' '} || Distance :${allData[0].distance?allData[0].distance+' km':' '} || Driver : ${allData[0]?.driverName?allData[0].driverName:' '} || Driver Contact Number : ${allData[0]?.driverPhnNum?allData[0].driverPhnNum:' '} || Vehicle Number : ${allData[0]?.vehicleNo?allData[0].vehicleNo:' '} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} ||  ${msg} `

                    contactDetails =["917036716813","919900064294",allData[0]?.hodContactNum,allData[0]?.empContactNumber,adminNum[0]?.contactNum]
                }
                
                let driverMessageContent=`Pick Up Request || Dear ${allData[0].driverName?allData[0].driverName+',':' '} || You Got The Ride !  || PickUp Location : ${allData[0]?.source?allData[0].source:' '}  || Destination : ${allData[0]?.destination?allData[0].destination:' '}|| PickUp Time : ${allData[0].pickUpTime?moment(allData[0].pickUpTime).format('YYYY-MM-DD HH:MM'):' '} || Requested By : ${allData[0].employeeName?allData[0].employeeName:''} || Contact : ${allData[0].empContactNumber?allData[0].empContactNumber:''} || User : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} ||  Please Contact Requested Person to Reach Location, ||  Thank You.`

                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent }, 
                ];

                const driverParameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": driverMessageContent }, 
                ];
                let statusFlag
                
                for (const contact of contactDetails) {
                    const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
                //    console.log(whatsappres,'whatsappppaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
                    const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    // console.log(messageStatus,'mesage statussssssssssssssssssssss')
                    if (!messageStatus.status) {
                        statusFlag = false
                        break

                    } else {
                        statusFlag = true
                    }

                }
                const contacts = ["917036716813","919900064294",allData[0]?.driverPhnNum]
                for (const contact of contacts) {
                const whatsappres = await new MessageParameters(contact, 'vrs_alert', driverParameters, 'en_us')
                const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                }
                
               
                return new CommonResponseModel(true,1,'Admin Approved Sucessfully', {'reqCode':reqData.vehicleReqCode,'EmpContact':allData[0]?.empContactNumber,'hodContact':allData[0]?.hodContactNum})
            }else{
                return new CommonResponseModel(false,0,'Something Went Wrong')
            }
        }catch(err){
            throw err
        }
    }

    async getAllVendorDetails(req:roleReq):Promise<CommonResponseModel>{
        try{
            const query='select vr.vehicle_category AS vehicleCategory,vr.trip_type AS tripType,vr.driver_id AS driverId,vr.vehicle_req_code AS vehicleReqCode,v.vendor_code as vendoruser, v.vendor_name as vendorname,v.phone_number as vendorPhnNum, vr.id,vr.employee_id AS employeeId,vr.source AS source,vr.destination AS destination, vr.no_of_people AS noOfPeople,vr.vehicle_required_on AS vehicleRequiredOn, vr.hod_approval_date AS hodApprovalDate,vr.admin_approval_date AS adminApprovalDate, vr.vehicle_type AS vehicleType,vr.vehicle_id AS vehicleId,vr.vendor_id AS vendorId, vr.cost,vr.distance,vr.status, e.employee_name AS employeeName,d.department_name AS departmentName,e.contact_number as empContactNum from vehicle_request vr left join employee e ON e.id= vr.employee_id left join department d ON d.id=vr.department_id left join vendor v on v.id=vr.vendor_id left join locations sl on sl.id = vr.source left join locations dl on dl.id = vr.destination  where v.vendor_code ="'+req.user+'" and status in ("'+VehicleStatus.WAITING_ON_VENDOR+'") and (status in ("'+VehicleStatus.VEHICLE_ASSIGNED+'") or vr.vehicle_type = "Vendor")'
           const result = await this.vehiclereqRepo.query(query);

           const query1='select vr.vehicle_category AS vehicleCategory,vr.trip_type AS tripType,vr.driver_id AS driverId,vr.vehicle_req_code AS vehicleReqCode,v.vendor_code as vendoruser, v.vendor_name as vendorname,v.phone_number as vendorPhnNum, vr.id,vr.employee_id AS employeeId,vr.source AS source,vr.destination AS destination, vr.no_of_people AS noOfPeople,vr.vehicle_required_on AS vehicleRequiredOn, vr.hod_approval_date AS hodApprovalDate,vr.admin_approval_date AS adminApprovalDate, vr.vehicle_type AS vehicleType,vr.vehicle_id AS vehicleId,vr.vendor_id AS vendorId, vr.cost,vr.distance,vr.status, e.employee_name AS employeeName,d.department_name AS departmentName,e.contact_number as empContactNum  from vehicle_request vr left join employee e ON e.id= vr.employee_id left join department d ON d.id=vr.department_id left join vendor v on v.id=vr.vendor_id left join locations sl on sl.id = vr.source left join locations dl on dl.id = vr.destination  where v.vendor_code ="'+req.user+'" and status in ("'+VehicleStatus.VEHICLE_ASSIGNED+'","'+VehicleStatus.TRIP_STARTED+'","'+VehicleStatus.TRIP_COMPLETED+'") and vr.vehicle_type = "Vendor"'
           const result1 = await this.vehiclereqRepo.query(query1);
           let data = [...result, ...result1]
           if(data){
            return new CommonResponseModel(true,1,'Data Retrived Sucessfully',data)
           }else{
            return new CommonResponseModel(false,0,'No Data Found',[])
           }

        }catch(err){
            throw err
        }
    }

    async updateVendorVehicelAssin(req:AdminApprovalreq):Promise<CommonResponseModel>{
        try{
            
            const update = await this.vehiclereqRepo.update({id:req.vehicleReqId},{vehicleId:req.veheicleId,driverId:req.driverId,cost:req.approxCost,distance:req.approxDistance,slabId:req.slabId,totalHrs:req.totalHrs,tripType:req.type,status:req.status})
            if(update.affected){
                const query = 'select contact_number as contactNum from employee where employee_name = "MRUTHUNJAYA.S"'
                const adminNum = await this.vehiclereqRepo.query(query)
                const allData = await this.getAllDetailsofvehReq(req.vehicleReqId)
                // let driverPhnNum =allData[0].driverPhnNum
                // let employeePhnNum=allData[0].empContactNumber
                // let hodPhnNum=allData[0].hodContactNum
                // let adminPhnNum=adminNum[0]?.contactNum
                //     if(allData[0].empContactNumber.length === 12){
                //         employeePhnNum = employeePhnNum
                //     }else{
                //         employeePhnNum = '91'+allData[0].empContactNumber
                //     }
                //     if(allData[0].driverPhnNum.length === 12){
                //         driverPhnNum = driverPhnNum
                //     }else{
                //         driverPhnNum = '91'+allData[0].driverPhnNum
                //     }
                //     if(allData[0].hodContactNum.length === 12){
                //         hodPhnNum = hodPhnNum
                //     }else{
                //         hodPhnNum = '91'+allData[0].hodContactNum
                //     }
                //     if(adminNum[0]?.contactNum.length === 12){
                //         adminPhnNum=adminPhnNum
                //     }else{
                //         adminPhnNum='91'+adminNum[0]?.contactNum
                //     }

                let messageContent=`Vehicle Request || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source :${allData[0]?.source?allData[0].source:' '} || Destination :${allData[0]?.destination?allData[0].destination:' '}|| Vehicle Type : ${allData[0].vehicleType?allData[0].vehicleType:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On :${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Cost : ${allData[0].cost?allData[0].cost + ' rs':' '} || Distance :${allData[0].distance?allData[0].distance:' '} || Vehicle Number : ${allData[0]?.vehicleNo?allData[0].vehicleNo:' '} || Vendor - ${allData[0].vendorName} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || Driver Name : ${allData[0].driverName?allData[0].driverName:' -'} || Driver Number : ${allData[0].driverPhnNum?allData[0].driverPhnNum:' -'} || Assigned vehicle `

                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent }, 
                ];
                  const  contactDetails =["917036716813","919900064294",allData[0].hodContactNum,allData[0].empContactNumber,adminNum[0]?.contactNum,allData[0].driverPhnNum]


                
                let statusFlag
                for (const contact of contactDetails) {
                    const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
                   
                    const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    if (!messageStatus.status) {
                        statusFlag = false
                        break

                    } else {
                        statusFlag = true
                    }

                }

                return new CommonResponseModel(true,1,'Vendor Asiigned Vehicle Sucessfully')
            }else{
                return new CommonResponseModel(false,0,'Something Went Wrong')
            }
        }catch(err){
            throw err
        }
    }

    async updateVendorVehicelDriverAssin(req:AdminApprovalreq):Promise<CommonResponseModel>{
        try{
            
            const update = await this.vehiclereqRepo.update({id:req.vehicleReqId},{driverId:req.driverId,status:VehicleStatus.VEHICLE_ASSIGNED})
            if(update.affected){
                const query = 'select contact_number as contactNum from employee where employee_name = "MRUTHUNJAYA.S"'
                const adminNum = await this.vehiclereqRepo.query(query)
                const allData = await this.getAllDetailsofvehReq(req.vehicleReqId)

                let driverPhnNum =allData[0].driverPhnNum
                let employeePhnNum=allData[0].empContactNumber
                let hodPhnNum=allData[0].hodContactNum
                let adminPhnNum=adminNum[0]?.contactNum
                    if(allData[0].empContactNumber != null && allData[0].empContactNumber.length === 12){
                        employeePhnNum = employeePhnNum
                    }else{
                        employeePhnNum = '91'+allData[0].empContactNumber
                    }
                    if(allData[0].driverPhnNum != null && allData[0].driverPhnNum.length === 12){
                        driverPhnNum = driverPhnNum
                    }else{
                        driverPhnNum = '91'+allData[0].driverPhnNum
                    }
                    if(allData[0].hodContactNum != null && allData[0].hodContactNum.length === 12){
                        hodPhnNum = hodPhnNum
                    }else{
                        hodPhnNum = '91'+allData[0].hodContactNum
                    }
                    if(adminNum[0]?.contactNum != null && adminNum[0]?.contactNum.length === 12){
                        adminPhnNum=adminPhnNum
                    }else{
                        adminPhnNum='91'+adminNum[0]?.contactNum
                    }

                let messageContent=`Vehicle Request || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source :${allData[0]?.source?allData[0].source:' '} || Destination :${allData[0]?.destination?allData[0].destination:' '}|| Vehicle Type : ${allData[0].vehicleType?allData[0].vehicleType:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On :${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Cost : ${allData[0].cost?allData[0].cost+' rs':' '} || Distance :${allData[0].distance?allData[0].distance:' '} || Driver : ${allData[0]?.driverName?allData[0].driverName:' '} || Driver Contact Number : ${allData[0]?.driverPhnNum?allData[0].driverPhnNum:' '} || Vehicle Number : ${allData[0]?.vehicleNo?allData[0].vehicleNo:' '} ||  Vendor- ${allData[0].vendorName} || User : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} Assigned Driver. `

                
                let driverMessageContent=`Pick Up Request || Dear ${allData[0].driverName?allData[0].driverName+',':' '} || You Got The Ride !  || PickUp Location : ${allData[0]?.source?allData[0].source:' '}  || Destination : ${allData[0]?.destination?allData[0].destination:' '}|| PickUp Time : ${allData[0].pickUpTime?moment(allData[0].pickUpTime).format('YYYY-MM-DD HH:MM'):' '} || Requested By : ${allData[0].employeeName?allData[0].employeeName:''} || Contact : ${allData[0].empContactNumber?allData[0].empContactNumber:''} || User : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || || Please Contact Requested Person to Reach Location, || || Thank You.`


                    // console.log(driverPhnNum,'driver phone number')
                const parameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": messageContent }, 
                ];
                const driverParameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": driverMessageContent }, 
                ];
                  const  contactDetails =["917036716813","919900064294",hodPhnNum,employeePhnNum,adminPhnNum,driverPhnNum]
                // const  contactDetails =['919502201959']

            //    console.log(contactDetails,'$$$$$$$$$$$$$$')
                
                let statusFlag
                for (const contact of contactDetails) {
                    const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
                   
                    const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    // console.log(messageStatus,'message statusss')
                    if (!messageStatus.status) {
                        statusFlag = false
                        break

                    } else {
                        statusFlag = true
                    }

                }
                const  allContactDetails =["917036716813","919900064294",driverPhnNum]
                for (const contact of allContactDetails) {
                const whatsappres = await new MessageParameters(contact, 'vrs_alert', driverParameters, 'en_us')
                   
                const driverMessageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                // console.log(driverMessageStatus,'message statusss')
                if (!driverMessageStatus.status) {
                    statusFlag = false
                } else {
                    statusFlag = true
                }
            }
                return new CommonResponseModel(true,1,'Vendor Asiigned Vehicle Sucessfully')
            }else{
                return new CommonResponseModel(false,0,'Something Went Wrong')
            }
        }catch(err){
            throw err
        }
    }

    async rejectVehicleReq(req:VehicleIdReq):Promise<CommonResponseModel>{
        const update = await this.vehiclereqRepo.update({id:req.vehicleId},{status:VehicleStatus.REJECTED})
        if(update.affected){
            return new CommonResponseModel(true,1,'Rejected Sucessfully' )
        }else{
            return new CommonResponseModel(false,0,'Something Went Wrong' )

        }
    }
     
    async getVehicleReqReportData(req:vehicleReportReq): Promise<CommonResponseModel> {
        try {
            const data = await this.vehiclereqRepo.getVehicleReqReportData(req)
            // console.log(data,"data");
            
            if (data) {
            // console.log(data,"data111111111111111");

                return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully..', data)
            } else {
                return new CommonResponseModel(false, 0, 'No Data Found..', data)

            }
        }
        catch (err) {
            throw err
        }

    }


    async getAssignedVehicleDetails(req:vehReq): Promise<CommonResponseModel> {
        try {
            const data = await this.vehiclereqRepo.getAssignedVehicleDetails(req)
            // console.log(data,"data");
            
            if (data) {
            // console.log(data,"data111111111111111");

                return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully..', data)
            } else {
                return new CommonResponseModel(false, 0, 'No Data Found..', data)

            }
        }
        catch (err) {
            throw err
        }

    }

    async getVehicleReportData(): Promise<CommonResponseModel> {
        try {
            const data = await this.vehiclereqRepo.getVehicleReportData()
            // console.log(data,"data");
            
            if (data) {
            // console.log(data,"data111111111111111");

                return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully..', data)
            } else {
                return new CommonResponseModel(false, 0, 'No Data Found..', data)

            }
        }
        catch (err) {
            throw err
        }

    }

    async getvehicledropdown(req?: VehicleRequest): Promise<CommonResponseModel> {
        try {
            const data = await this.vehiclereqRepo.getvehicledropdown(req)
            // console.log(data,"data");
            
            if (data) {
            // console.log(data,"data111111111111111");

                return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully..', data)
            } else {
                return new CommonResponseModel(false, 0, 'No Data Found..', data)

            }
        }
        catch (err) {
            throw err
        }

    }
    async getHoddropdown(req?: VehicleRequest): Promise<CommonResponseModel> {
        try {
            const data = await this.vehiclereqRepo.getHoddropdown(req)
            // console.log(data,"data");
            
            if (data) {
            // console.log(data,"data111111111111111");

                return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully..', data)
            } else {
                return new CommonResponseModel(false, 0, 'No Data Found..', data)

            }
        }
        catch (err) {
            throw err
        }

    }
    async getAdmindropdown(req?: VehicleRequest): Promise<CommonResponseModel> {
        try {
            const data = await this.vehiclereqRepo.getAdmindropdown(req)
            // console.log(data,"data");
            
            if (data) {
            // console.log(data,"data111111111111111");

                return new CommonResponseModel(true, 1, 'Data Retrived Sucessfully..', data)
            } else {
                return new CommonResponseModel(false, 0, 'No Data Found..', data)

            }
        }
        catch (err) {
            throw err
        }

    }
    async updateTripDetails(req:any): Promise<CommonResponseModel> {
        // console.log(req,"serviceeeeeee")
        try {
            
            const getData = await this.vehiclereqRepo.findOne({where:{id:req.vehicleReqCode}});
            const updateReq = await this.vehiclereqRepo.update({id:req.vehicleReqCode},{openingKms : req.openingKms,
                closingKms : req.closingKms,
                totalKms : req.totalKms,
                tollCharges : req.tollCharges,
                totalAmount : req.totalAmount,
                onDutyTime : req.onDutyTime,
                offDutyTime : req.offDutyTime,
                extraHrs:req.extraHours,
                extraKms:req.extraKms,
                extraHrsCharges:req.extraHrsCharges,
                extraKmsCharges:req.extraKmsCharges,
                type:req.type,
                slabId:req.slabId,
                cost:req.cost,
                bata:req.bata,status:VehicleStatus.TRIP_COMPLETED})
            if(updateReq){
                let updateVehStatus = await this.vehiclerepo.update({id:getData.vehicleId},{vehicleStatus:VehicleStatusenum.NOT_OCCUPIED});
                if(updateVehStatus){
                    const query = 'select contact_number as contactNum from employee where employee_name = "MRUTHUNJAYA.S"'
                    const adminNum = await this.vehiclereqRepo.query(query)
                    const allData = await this.getAllDetailsofvehReq(req.vehicleReqCode)
                    // console.log(allData);
                    let msg
                    let messageContent
                    let contactDetails

                    if(req.vehicleType === VehicletypeEnum.VENDOR_VEHICLE){
                        msg='Note : Trip Completed '
                        messageContent=`Trip Info Updated || Source : ${allData[0]?.source?allData[0].source:' '} || Destination : ${allData[0]?.destination?allData[0].destination:' '}|| Vehicle Type : ${allData[0].vehicleType?allData[0].vehicleType:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On : ${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Trip TYpe : ${allData[0]?.type?allData[0]?.type:' '} || Cost : ${allData[0]?.totalCost?allData[0]?.totalCost+' rs':' '} || Distance :${allData[0]?.totalDistance?allData[0]?.totalDistance+' km':' '} || Driver : ${allData[0]?.driverName?allData[0].driverName:' '} || Driver Contact Number : ${allData[0]?.driverPhnNum?allData[0].driverPhnNum:' '} || Vehicle Number : ${allData[0]?.vehicleNo?allData[0].vehicleNo:' '} || User : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || ${msg} `

                        contactDetails =[allData[0]?.hodContactNum,allData[0]?.empContactNumber,adminNum[0]?.contactNum,allData[0]?.vendorPhoneNumber]
                    }else{
                        msg='Note : Trip Completed'
                        messageContent=`Trip Info Updated || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source : ${allData[0]?.source?allData[0].source:' '} || Destination : ${allData[0]?.destination?allData[0].destination:' '} || Vehicle : ${allData[0]?.assgnedVehicle?allData[0].assgnedVehicle:' '} || Vehicle Type : ${allData[0].vehicleType?allData[0].vehicleType:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On : ${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Trip TYpe : ${allData[0]?.type?allData[0]?.type:' '} || Cost : ${allData[0]?.totalCost?allData[0]?.totalCost+' rs':' '} || Distance :${allData[0]?.totalDistance?allData[0]?.totalDistance+' km':' '} || Driver : ${allData[0]?.driverName?allData[0].driverName:' '} || Driver Contact Number : ${allData[0]?.driverPhnNum?allData[0].driverPhnNum:' '} || Vehicle Number : ${allData[0]?.vehicleNo?allData[0].vehicleNo:' '} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || ${msg} `

                        contactDetails =["917036716813","919900064294",allData[0]?.hodContactNum,allData[0]?.empContactNumber,adminNum[0]?.contactNum]
                    }
                    
                    let driverMessageContent=`Trip Completed || Dear ${allData[0].driverName?allData[0].driverName+',':' '} || You have successfully completed The Ride !  || PickUp Location : ${allData[0]?.source?allData[0].source:' '}  || Destination : ${allData[0]?.destination?allData[0].destination:' '}|| PickUp Time : ${allData[0].pickUpTime?moment(allData[0].pickUpTime).format('YYYY-MM-DD HH:MM'):' '} || Requested By : ${allData[0].employeeName?allData[0].employeeName:''} || Contact : ${allData[0].empContactNumber?allData[0].empContactNumber:''} || User : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || || Please wait for the next ride. || || Thank You.`

                    const parameters = [
                        { "type": "text", "text": moment().format('YYYY-MM-DD') },
                        { "type": "text", "text": messageContent }, 
                    ];

                    const driverParameters = [
                        { "type": "text", "text": moment().format('YYYY-MM-DD') },
                        { "type": "text", "text": driverMessageContent }, 
                    ];
                    let statusFlag
                    
                    for (const contact of contactDetails) {
                        const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
                    // console.log(whatsappres,'whatsappppaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
                        const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                        // console.log(messageStatus,'mesage statussssssssssssssssssssss')
                        if (!messageStatus.status) {
                            statusFlag = false
                            break

                        } else {
                            statusFlag = true
                        }

                    }
                    const whatsappres = await new MessageParameters(allData[0]?.driverPhnNum, 'vrs_alert', driverParameters, 'en_us')
                    const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    
                    return new CommonResponseModel(true, 1, 'Trip Details updated successfully')
                }
                else{
                    return new CommonResponseModel(false, 0, 'something went wrong. ')
                }
            }
            else{
                return new CommonResponseModel(false, 0, 'something went wrong. ')
            }
        } catch (err) {
            throw err
        }
    }

    // async createTripDetails(req: TripReq): Promise<CommonResponseModel> {

    //     try {
    //         const entity = new VehicleRequestEntity()
    //         entity.openingKms = req.openingKms;
    //         entity.closingKms = req.closingKms;
    //         entity.totalKms = req.totalKms;
    //         entity.extraHrs = req.extraHrs;
    //         entity.extraKms = req.extraKms;            
    //         entity.bata = req.bata;
    //         entity.tollCharges = req.tollCharges;
    //         entity.totalAmount = req.totalAmount;
    //         entity.onDutyTime = req.onDutyTime;
    //         entity.offDutyTime = req.offDutyTime;
    //         entity.type = req.type;
    //         entity.createdUser = req.createdUser;
    //         entity.isActive = req.isActive;
    //         entity.versionFlag = req.versionFlag;
    //         entity.updatedUser = req.updatedUser;
    //         if (req.id) {
    //             entity.updatedUser = req.createdUser
    //         } else {
    //             entity.createdUser = req.createdUser
    //         }
    //         const save = await this.vehiclereqRepo.save(entity)
    //         if (!save) {

    //             return new CommonResponseModel(false, 0, 'Something went wrong in Trip Details creation', [])
    //         } else {

    //             return new CommonResponseModel(true, 1, 'Created successfully', save)
    //         }

    //     } catch (err) {

    //         throw err
    //     }
    // }

    async getAssignedVehicles(): Promise<CommonResponseModel> {
        try{
            const getVehicleData =  await this.vehiclereqRepo.find({where:{status:VehicleStatus.VEHICLE_ASSIGNED}});
            if(getVehicleData.length > 0){
                return new CommonResponseModel(true,1,'Vehicle Details retrived. ', getVehicleData);
            }
            else{
                return new CommonResponseModel(false,0,'No data found. ');
            }
        }
        catch (err) {
            throw err
        }
    }
    async getAssignedVehiclesByVehicleType(req:VehicleTypeReq): Promise<CommonResponseModel> {
        try{
            const query = 'select id as id from vendor where vendor_code = "'+req.vendorCode+'"'
                    const vendorId = await this.vehiclereqRepo.query(query)
            if(req.vehiclesType === VehicletypeEnum.VENDOR_VEHICLE){
                const getVehicleData =  await this.vehiclereqRepo.find({where:{status:VehicleStatus.VEHICLE_ASSIGNED, vehicleType:req.vehiclesType,vendorId:vendorId[0].id}});
                if(getVehicleData.length > 0){
                    return new CommonResponseModel(true,1,'Vehicle Details retrived. ', getVehicleData);
                }
                else{
                    return new CommonResponseModel(false,0,'No data found. ');
                }
            }
            else{
                const getVehicleData =  await this.vehiclereqRepo.find({where:{status:VehicleStatus.VEHICLE_ASSIGNED, vehicleType:req.vehiclesType}});
                if(getVehicleData.length > 0){
                    return new CommonResponseModel(true,1,'Vehicle Details retrived. ', getVehicleData);
                }
                else{
                    return new CommonResponseModel(false,0,'No data found. ');
                }
            }
           
        }
        catch (err) {
            throw err
        }
    }

    //dashboard API
    async getVehicleReqStatusCount(): Promise<CommonResponseModel> {
        try{
                const vehicleReqStatus = Object.values(VehicleStatus)
                .map(status => `'${status}'`)
                .join(', ');
                // console.log(Object.values(VehicleStatus))
                let data:any[] = [];
                for(const res of Object.values(VehicleStatus)){
                    if(res === VehicleStatus.REJECTED){
                        const query = 'select count(*) as count, "HOD Rejected" from vehicle_request where status="'+res+'" and hod_approval_date IS NULL';
                        const statusCount = await this.vehiclereqRepo.query(query)
                        data.push(statusCount);
                        const query1 = 'select count(*) as count, "ADMIN Rejected" from vehicle_request where status="'+res+'" and admin_approval_date IS NULL';
                        const statusCount1 = await this.vehiclereqRepo.query(query1)
                        data.push(statusCount1);
                    }
                    else{
                        const query = 'select count(*) as count, "'+res+'" from vehicle_request where status="'+res+'"';
                        const statusCount = await this.vehiclereqRepo.query(query)
                        data.push(statusCount);
                    }
                }
                if(data.length > 0){
                    return new CommonResponseModel(true,1,'Vehicle Details retrived. ', data);
                }
                else{
                    return new CommonResponseModel(false,0,'No data found. ');
                }
        }
        catch (err) {
            throw err
        }
    }

    // Dashboard API
    async getTotalVehiclesCount(): Promise<CommonResponseModel> {
        const query = `SELECT count(*) AS totalVehicles from vehicle`;
        const result = await this.vehiclerepo.query(query);
        if (result) {
          return new CommonResponseModel(true, 1, "Data Retrived", result);
    
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }

      // Dashboard API
    async getVehicleSummary(req:DatesDto): Promise<CommonResponseModel> {
        const query = `SELECT mark_model AS vehicleModel from vehicle`;
        const result = await this.vehiclerepo.query(query);
        if (result) {
            let data:any = [];
            let available:any[] = [];
            let onTrip:any[] = [];
            let scheduled:any[] = [];
            let outOfService:any[] = [];
            let total:any[] = [];
            for(const res of result){
                const vehInhouseCountQuery = `SELECT count(*) AS count, 'In House' AS vehicleType from vehicle where status = 'NOT OCCUPIED' and mark_model = ''`+res.vehicleModel+ `'' and vehicle_type = 'In House'`;
                const vehInhouseCount = await this.vehiclerepo.query(vehInhouseCountQuery);
                const vehVendorCountQuery = `SELECT count(*) AS count, 'Vendor' AS vehicleType from vehicle where status = 'NOT OCCUPIED' and mark_model = '`+res.vehicleModel+ `' and vehicle_type = 'Vendor'`;
                const vehVenodrCount = await this.vehiclerepo.query(vehVendorCountQuery);
                // console.log(vehInhouseCount);
                // console.log(vehVenodrCount);
                const onTripInhouseCountQuery = `SELECT count(*) AS count, 'In House' AS vehicleType from vehicle_request vr left join vehicle v on v.id = vr.vehicle_id where vehicle_required_on = '`+req.fromDate+`' and v.mark_model = ''`+res.vehicleModel+ `'' and v.vehicle_type = 'In House'`;
                const onTripInhouseCount = await this.vehiclerepo.query(onTripInhouseCountQuery);
                const onTripvehVendorCountQuery = `SELECT count(*) AS count, 'Vendor' AS vehicleType from vehicle_request vr left join vehicle v on v.id = vr.vehicle_id where vehicle_required_on = '`+req.fromDate+`' and v.mark_model = '`+res.vehicleModel+ `' and v.vehicle_type = 'Vendor'`;
                const onTripvehVenodrCount = await this.vehiclerepo.query(onTripvehVendorCountQuery);

                const scheduledInhouseCountQuery = `SELECT count(*) AS count, 'In House' AS vehicleType from vehicle_request vr left join vehicle v on v.id = vr.vehicle_id where vehicle_required_on != '`+req.fromDate+`' and v.mark_model = ''`+res.vehicleModel+ `'' and v.vehicle_type = 'In House'`;
                const scheduledInhouseCount = await this.vehiclerepo.query(scheduledInhouseCountQuery);
                const scheduledvehVendorCountQuery = `SELECT count(*) AS count, 'Vendor' AS vehicleType from vehicle_request vr left join vehicle v on v.id = vr.vehicle_id where vehicle_required_on != '`+req.fromDate+`' and v.mark_model = '`+res.vehicleModel+ `' and v.vehicle_type = 'Vendor'`;
                const scheduledvehVenodrCount = await this.vehiclerepo.query(scheduledvehVendorCountQuery);

                const outOfServiceInhouseCountQuery = `SELECT count(*) AS count, 'In House' AS vehicleType from vehicle v where status= 'MAINTAINANCE' and v.mark_model = ''`+res.vehicleModel+ `'' and v.vehicle_type = 'In House'`;
                const outOfServiceInhouseCount = await this.vehiclerepo.query(outOfServiceInhouseCountQuery);
                const outOfServicevehVendorCountQuery = `SELECT count(*) AS count, 'Vendor' AS vehicleType from vehicle v where status= 'MAINTAINANCE' and v.mark_model = '`+res.vehicleModel+ `' and v.vehicle_type = 'Vendor'`;
                const outOfServicevehVenodrCount = await this.vehiclerepo.query(outOfServicevehVendorCountQuery);

                const totalInhouseCountQuery = `SELECT count(*) AS count, 'In House' AS vehicleType from vehicle v where v.mark_model = ''`+res.vehicleModel+ `'' and v.vehicle_type = 'In House'`;
                const totalInhouseCount = await this.vehiclerepo.query(totalInhouseCountQuery);
                const totalvehVendorCountQuery = `SELECT count(*) AS count, 'Vendor' AS vehicleType from vehicle v where v.mark_model = '`+res.vehicleModel+ `' and v.vehicle_type = 'Vendor'`;
                const totalvehVenodrCount = await this.vehiclerepo.query(totalvehVendorCountQuery);

                available.push({'InHouse':vehInhouseCount[0].count, 'vendor':vehVenodrCount[0].count});
                onTrip.push({'InHouse':onTripInhouseCount[0].count, 'vendor':onTripvehVenodrCount[0].count});
                scheduled.push({'InHouse':scheduledInhouseCount[0].count, 'vendor':scheduledvehVenodrCount[0].count});
                outOfService.push({'InHouse':outOfServiceInhouseCount[0].count, 'vendor':outOfServicevehVenodrCount[0].count});
                total.push({'InHouse':totalInhouseCount[0].count, 'vendor':totalvehVenodrCount[0].count});
            }
            data.push(available);
            data.push(onTrip);
            data.push(scheduled);
            data.push(outOfService);
            data.push(total);
           // console.log('********************************');
           // console.log(data);

        if(data.length > 0){
            return new CommonResponseModel(true, 1, "Data Retrived", data,result);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }
    }
   
     // Dashboard API
     async getVehicleRenwalsData(): Promise<CommonResponseModel> {
        const query = `SELECT
        SUM(CASE WHEN DATEDIFF(NOW(), insurance_expiry_date) > 30 THEN 1 ELSE 0 END) AS count_above_30_days_insurance_expiry_date,
        SUM(CASE WHEN DATEDIFF(NOW(), insurance_expiry_date) > 60 THEN 1 ELSE 0 END) AS count_above_60_days_insurance_expiry_date,
        SUM(CASE WHEN DATEDIFF(NOW(), insurance_expiry_date) > 90 THEN 1 ELSE 0 END) AS count_above_90_days_insurance_expiry_date,
        SUM(CASE WHEN DATEDIFF(NOW(), road_tex_last_date) > 30 THEN 1 ELSE 0 END) AS count_above_30_days_road_tex_last_date,
        SUM(CASE WHEN DATEDIFF(NOW(), road_tex_last_date) > 60 THEN 1 ELSE 0 END) AS count_above_60_days_road_tex_last_date,
        SUM(CASE WHEN DATEDIFF(NOW(), road_tex_last_date) > 90 THEN 1 ELSE 0 END) AS count_above_90_days_road_tex_last_date,
        SUM(CASE WHEN DATEDIFF(NOW(), national_permit_last_date) > 30 THEN 1 ELSE 0 END) AS count_above_30_days_national_permit_last_date,
        SUM(CASE WHEN DATEDIFF(NOW(), national_permit_last_date) > 60 THEN 1 ELSE 0 END) AS count_above_60_days_national_permit_last_date,
        SUM(CASE WHEN DATEDIFF(NOW(), national_permit_last_date) > 90 THEN 1 ELSE 0 END) AS count_above_90_days_national_permit_last_date FROM vehicle`;
        const result = await this.vehiclerepo.query(query);
        let data:any[] = [];
        if (result) {
            let roadTax = {'name':'Road Tax', 'data':[result[0].count_above_30_days_road_tex_last_date,result[0].count_above_60_days_road_tex_last_date,result[0].count_above_90_days_road_tex_last_date]}
            let nationalPermit = {'name':'National Permit', 'data':[result[0].count_above_30_days_national_permit_last_date,result[0].count_above_60_days_national_permit_last_date,result[0].count_above_90_days_national_permit_last_date]}
            let insurance = {'name':'Insurance', 'data':[result[0].count_above_30_days_insurance_expiry_date,result[0].count_above_60_days_insurance_expiry_date,result[0].count_above_90_days_insurance_expiry_date]}
            data.push(roadTax)
            data.push(nationalPermit)
            data.push(insurance)
            if(data.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", data);
            }
            else {
                return new CommonResponseModel(false, 0, "No data found. ");
              }
        } else {
            return new CommonResponseModel(false, 0, "No data found. ");
        }
      }
      
      //Dashboard API
      getMonthsBetweenDates(startDate: Date, endDate: Date): string[] {
       // console.log(startDate);
        //console.log(endDate);

        const months: string[] = [];
        let currentDate = new Date(startDate);
        let endDates = new Date(endDate);

    
        while (currentDate <= endDates) {
          const month = currentDate.toLocaleString('default', { month: 'short' });
          months.push(month);
          
          // Move to the next month
          currentDate.setMonth(currentDate.getMonth() + 1);
        }
    
        return months;
      }


      async getDatesInMonth(year: number, month: number): Promise<string[]> {
        const dates: string[] = [];
        // Adjust month for zero-based indexing
        const daysInMonth = new Date(year, month + 1, 0).getDate(); // Correct calculation for the number of days in the month
        
        for (let day = 1; day <= daysInMonth; day++) {
            if(day > 1){
                const currentDate = new Date(year, month -1, day); // Correctly handles month as zero-based
                //console.log(`Current Date: ${currentDate}`);
                const dateString = currentDate.toISOString().split('T')[0]; // Format to YYYY-MM-DD
                dates.push(dateString);
            }
        }
        
        return dates;
    }

      //Dashboard API
    async getBudgetVSExpenditure(req:DatesDto): Promise<CommonResponseModel> {
        let dates:any[] = await this.getMonthsBetweenDates(req.fromDate,req.toDate)
       // console.log(dates);
        //console.log(Object.values(dates))
        let budgets:any[] = [];
        let expenditures:any[] = [];
        let response:any[] = [];
        for(const res of Object.values(dates)){
          //  console.log(res);
            const budgetQuery = `SELECT IF(DATE_FORMAT(from_date, '%b') IS null, '`+res+`',DATE_FORMAT(from_date, '%b')) AS month, IF(budget IS null, 0, budget) AS budget from budget WHERE departmentName = `+req.department+` and DATE_FORMAT(from_date, '%b') = '`+res+`'`;
            const budget = await this.vehiclerepo.query(budgetQuery);
            const expenditureQuery = `SELECT IF(DATE_FORMAT(vehicle_required_on, '%b') IS null, '`+res+`',DATE_FORMAT(vehicle_required_on, '%b')) AS month, IF(SUM(cost) IS null, 0,SUM(cost)) AS expenditure from vehicle_request v left join employee e on e.id = v.employee_id left join department d on d.id = e.department_name WHERE d.id = `+req.department+` and DATE_FORMAT(vehicle_required_on, '%b') = '`+res+`'`;
            const expenditure = await this.vehiclerepo.query(expenditureQuery);
          //  console.log(budget)
            //console.log(expenditure)
            if(budget.length === 0){
                budgets.push(0)
            }
            else{
                budgets.push(budget[0].budget)
            }
            if(expenditure.length === 0){
                expenditures.push(0)
            }
            else{
                expenditures.push(expenditure[0].expenditure)
            }
        }
       // console.log(budgets);
        //console.log(expenditures);
        response.push({'name':'Budgets','data':budgets})
        response.push({'name':'Expenditures','data':expenditures})
        if (response.length > 0) {
            return new CommonResponseModel(true, 1, "Data Retrived. ", response);
        }
        else {
            return new CommonResponseModel(false, 0, "No data found. ");
        }
    }

    async getVehicleAvaialbleVSOccupied(req:DatesDto): Promise<CommonResponseModel> {
        try{
            let dates = await this.getDatesInMonth(Number(moment(req.fromDate).format("YYYY")),Number(moment(req.fromDate).format("MM")));
            if(dates){
              //  console.log(dates)
                let avail:any[] = [];
                let occupied:any[] = [];
                let response:any[] = [];
                for(const res of Object.values(dates))
                {
                    //console.log(res);
                    const inHousevehicleoccupied = `select count(vehicle_id) as cnt, group_concat(vehicle_id) AS occupiedIds from vehicle_request where vehicle_required_on = '`+res+`' and vehicle_type = 'IN HOUSE'`;
                    const inHouseoccupiedData = await this.vehiclerepo.query(inHousevehicleoccupied);

                    const inHousevehicleAvail = `select count(id) AS cnt from vehicle where vehicle_type = 'In House' and id not in (`+inHouseoccupiedData[0].occupiedIds+`)`;
                    const inHouseavailData = await this.vehiclerepo.query(inHousevehicleAvail);
                   // console.log(inHouseoccupiedData);
                    //console.log(inHouseavailData);


                    // const vendorvehicleoccupied = `select count(vehicle_id) as cnt, group_concat(vehicle_id) AS occupiedIds from vehicle_request where vehicle_required_on = '`+res+`' and vehicle_type = 'Vendor'`;
                    // const vendoroccupiedData = await this.vehiclerepo.query(vendorvehicleoccupied);

                    // const vendorvehicleAvail = `select count(id) AS cnt from vehicle where vehicle_type = 'Vendor' and id not in (`+vendoroccupiedData[0].occupiedIds+`)`;
                    // const vendoravailData = await this.vehiclerepo.query(vendorvehicleAvail);
                    // console.log(vendoroccupiedData);
                    // console.log(vendoravailData);

                    avail.push(inHouseoccupiedData[0].cnt)
                    occupied.push(inHouseavailData[0].cnt)

                    // vendor.push(inHouseavailData[0].cnt)
                    // vendor.push(vendoravailData[0].cnt)
                    // response.push({'name':'Available','data':vendor})

                }
                response.push({'name':'Available','data':avail})
                response.push({'name':'Occupied','data':occupied})


                // console.log(response);
                if(response){
                    return new CommonResponseModel(true, 1, "Data Retrived. ", response);
                }
                else {
                    return new CommonResponseModel(false, 0, "No data found. ");
                }

            }
            else {
                return new CommonResponseModel(false, 0, "No data found. ");
            }
        }catch (err) {
            throw err
        }
    }

    async getVehicleIssueStatus(): Promise<CommonResponseModel> {
        try{
            const getpendingIssuesCount = `select count(id) as cnt from vehicle_issue where Vehicle_Status = 'PENDING'`;
            const pendingIssues = await this.vehiclerepo.query(getpendingIssuesCount);
            const getInProgressIssuesCount = `select count(id) as cnt from vehicle_issue where Vehicle_Status = 'IN PROGRESS'`;
            const InProgressIssues = await this.vehiclerepo.query(getInProgressIssuesCount);
            const getServicePending = `select count(id) as cnt from vehicle where status = 'MAINTAINANCE'`;
            const servicePendingCount = await this.vehiclerepo.query(getServicePending);
            if(pendingIssues.length > 0 || InProgressIssues.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", {'pendingIssues':pendingIssues[0].cnt,'InprogressIssues':InProgressIssues[0].cnt, 'serviceInprogressVehicles':servicePendingCount[0].cnt});
            }
            else{
                return new CommonResponseModel(false, 0, "No data found. ", {'pendingIssues':0,'InprogressIssues':0});
            }
        }catch (err) {
            throw err
        }
    }
    async getTop5VehicleIssues(): Promise<CommonResponseModel> {
        try{
            const getVehicleIssues = `select v.vehicle_name AS vehicleName, title AS issue, vehicle_status AS status, DATEDIFF(CURDATE(), due_date) AS age from vehicle_issue vi left join vehicle v on v.id = vi.vehicle_id where vi.vehicle_Status IN ('OPEN','IN PROGRESS') limit 5`;
            const pendingIssues = await this.vehiclerepo.query(getVehicleIssues);
            
            if(pendingIssues.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", pendingIssues);
            }
            else{
                return new CommonResponseModel(false, 0, "No data found.    ",);
            }
        }catch (err) {
            throw err
        }
    }

    async getTop5RenwalVehicles(): Promise<CommonResponseModel> {
        try{
            let data:any[] = [];
            const insuranceQuery = `SELECT vehicle_name AS vehicle, 'Open' AS STATUS, DATEDIFF(CURDATE(), insurance_expiry_date) AS age, 'Insurance' AS renwalType, insurance_expiry_date FROM vehicle WHERE DATEDIFF(CURDATE(), insurance_expiry_date) >= 5 LIMIT 5 `;
            const insurance = await this.vehiclerepo.query(insuranceQuery);
            const nationalPermit = `SELECT vehicle_name AS vehicle, 'Open' AS STATUS, DATEDIFF(CURDATE(), national_permit_last_date) AS age, 'National Permit' AS renwalType, national_permit_last_date FROM vehicle WHERE DATEDIFF(CURDATE(), national_permit_last_date) >= 5 LIMIT 5`;
            const national = await this.vehiclerepo.query(nationalPermit);
            const roadTaxQuery = `SELECT vehicle_name AS vehicle, 'Open' AS STATUS, DATEDIFF(CURDATE(), road_tex_last_date) AS age, 'Road Tax' AS renwalType, road_tex_last_date FROM vehicle WHERE DATEDIFF(CURDATE(), road_tex_last_date) >= 5 LIMIT 5`;
            const roadTax = await this.vehiclerepo.query(roadTaxQuery);
            data.push(...insurance,...national,...roadTax);
            let response = data.sort((a, b) => b['age'] - a['age']).slice(0,5);
            if(data.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", response);
            }
            else{
                return new CommonResponseModel(false, 0, "No data found. ",);
            }
        }catch (err) {
            throw err
        }
    }
    async getTop5ServiceInprogress(): Promise<CommonResponseModel> {
        try{
            let data:any[] = [];
            const servicePending = `Select vehicle_name AS vehicle, 'MAINTAINANCE' AS serviceType, status, DATEDIFF(CURDATE(), vehicle_servicing_date) AS age from vehicle where status = 'MAINTAINANCE' `;
            const serviceData = await this.vehiclerepo.query(servicePending);
            if(serviceData.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", serviceData);
            }
            else{
                return new CommonResponseModel(false, 0, "No data found. ",);
            }
        }catch (err) {
            throw err
        }
    }

    async getVendorsInfo(req:DatesDto): Promise<CommonResponseModel> {
        try{
            let available:any[] = [];
            let onTrip:any[] = [];
            let scheduled:any[] = [];
            let outOfServices:any[] = [];
            let totalVehicle:any[] = [];
            let totalTrip:any[] = [];
            let totalExpenditure:any[] = [];
            let totalKmss:any[] = [];
            let data:any[] = [];
            const getVendors = `Select vendor_name AS vendor,id from vendor where is_active is true`;
            const vendorsData = await this.vehiclerepo.query(getVendors);
            if(vendorsData.length > 0){
                for(const res of vendorsData){
                    let query = `Select count(id) AS cnt from vehicle where status = 'NOT OCCUPIED'`;
                    let availVeh = await this.vehiclerepo.query(query)
                    let onTripquery = `Select count(id) AS cnt from vehicle_request where vehicle_required_on = '`+req.fromDate+`' and vendor_id = `+res.id;
                    let onTripVehData = await this.vehiclerepo.query(onTripquery)
                    let onTripScheduledquery = `Select count(id) AS cnt from vehicle_request where vendor_id = `+res.id+` and vehicle_required_on != '`+req.fromDate+`'`;
                    let onTripScheduledVehData = await this.vehiclerepo.query(onTripScheduledquery)
                    let outOfService = `Select count(id) AS cnt from vehicle where status = 'MAINTAINANCE'`;
                    let outOfServiceData = await this.vehiclerepo.query(outOfService)
                    let totalVehicles = `Select count(id) AS cnt from vehicle where vehicle_type = 'Vendor'`;
                    let totalVehiclesData = await this.vehiclerepo.query(totalVehicles)
                    let totalTrips = `Select count(id) AS cnt from vehicle_request where vendor_id = `+res.id;
                    let totalNofTrips = await this.vehiclerepo.query(totalTrips)
                    let totalexpenditureQuery = `Select sum(cost) AS cnt from vehicle_request where vendor_id = `+res.id;
                    let totalExpenditures = await this.vehiclerepo.query(totalexpenditureQuery)
                    let totalKmsQuery = `Select sum(distance) AS cnt from vehicle_request where vendor_id = `+res.id;
                    let totalKms = await this.vehiclerepo.query(totalKmsQuery);
                    available.push(availVeh[0].cnt)
                    onTrip.push(onTripVehData[0].cnt)
                    scheduled.push(onTripScheduledVehData[0].cnt)
                    outOfServices.push(outOfServiceData[0].cnt)
                    totalVehicle.push(totalVehiclesData[0].cnt)
                    totalTrip.push(totalNofTrips[0].cnt)
                    totalExpenditure.push(totalExpenditures[0].cnt)
                    totalKmss.push(totalKms[0].cnt)
                }
                data.push(available);
                data.push(onTrip);
                data.push(scheduled);
                data.push(outOfServices);
                data.push(totalVehicle);
                data.push(totalTrip);
                data.push(totalExpenditure);
                data.push(totalKmss);
                if(data.length > 0){
                    return new CommonResponseModel(true, 1, "Data Retrived. ", data,vendorsData);
                }
                else{
                    return new CommonResponseModel(false, 0, "No data found. ",);
                }
            }
            else{
                return new CommonResponseModel(false, 0, "No data found. ",);
            }
        }catch (err) {
            throw err
        }
    }

    async RejectionsData(req:DatesDto): Promise<CommonResponseModel> {
        try{
            let data:any[]=[];
            const getVendors = `Select vendor_name AS vendor,id from vendor where is_active is true`;
            const vendorsData = await this.vehiclerepo.query(getVendors);
            let hodRejectedquery = `SELECT count(*) AS cnt from vehicle_request vr where status = 'REJECTED' and hod_approval_date IS NULL and vehicle_required_on ='`+req.fromDate+`'`;
            const hodRejected = await this.vehiclerepo.query(hodRejectedquery);
            let adminRejectedQuery = `SELECT count(*) AS cnt from vehicle_request vr where status = 'REJECTED' and admin_approval_date IS NULL and vehicle_required_on ='`+req.fromDate+`'`;
            const adminRejected = await this.vehiclerepo.query(adminRejectedQuery);
            data.push({'name': 'HOD', 'y':hodRejected[0].cnt})
            data.push({'name': 'ADMIN', 'y':adminRejected[0].cnt})
            for(const res of vendorsData){
                let query1 = `SELECT count(*) AS cnt, '`+res.vendor+`' AS name from vehicle_request vr left join vendor v on v.id = vr.vendor_id where status = 'REJECTED' and vendor_id =`+res.id+ ` and vehicle_required_on ='`+req.fromDate+`'`;
                const vendorData = await this.vehiclerepo.query(query1);
                data.push({'name': vendorData[0].name, 'y':vendorData[0].cnt})
            }
            if(data.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ",data);
            }else{
                return new CommonResponseModel(false, 0, "No data found. ",);
            }

        }catch (err) {
            throw err
        }
    }

    async getServicePendingAge(): Promise<CommonResponseModel> {
        const query = `SELECT
        SUM(CASE WHEN DATEDIFF(NOW(), vehicle_servicing_date) > 30 THEN 1 ELSE 0 END) AS count_above_30_days_vehicle_servicing_date,
        SUM(CASE WHEN DATEDIFF(NOW(), vehicle_servicing_date) > 60 THEN 1 ELSE 0 END) AS count_above_60_days_vehicle_servicing_date,
        SUM(CASE WHEN DATEDIFF(NOW(), vehicle_servicing_date) > 90 THEN 1 ELSE 0 END) AS count_above_90_days_vehicle_servicing_date,
        SUM(CASE WHEN DATEDIFF(NOW(), national_permit_last_date) > 90 THEN 1 ELSE 0 END) AS count_above_90_days_national_permit_last_date FROM vehicle`;
        const result = await this.vehiclerepo.query(query);
        let data:any[] = [];
        if (result) {
            data.push({'name':'Servicing', 'data':[result[0].count_above_30_days_vehicle_servicing_date,result[0].count_above_60_days_vehicle_servicing_date,result[0].count_above_90_days_vehicle_servicing_date]})
            if(data.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", data);
            }
            else {
                return new CommonResponseModel(false, 0, "No data found. ");
              }
        } else {
            return new CommonResponseModel(false, 0, "No data found. ");
        }
      }
    async getRequestRateAndPendingApprovals(req:DatesDto): Promise<CommonResponseModel> {
        try{
            let fromDate = new Date(req.fromDate);
            let month = fromDate.toLocaleString('default', { month: 'short' })
            let currentYear = fromDate.getFullYear();
            let currentMonth = fromDate.getMonth();
            let daysInmonth = new Date(currentYear, currentMonth, 0).getDate();
            // console.log(month)
            // console.log(currentYear)
            // console.log(currentMonth)
            // console.log(daysInmonth)


            let data:any[] = [];
            let pendingRequestsforAdminQuery = 'Select count(*) AS cnt, "ADMIN" AS name from vehicle_request vr where status = "ADMIN APPROVAL PENDING"';
            let pendingRequestsforHodQuery = 'Select count(*) AS cnt, "HOD" AS name from vehicle_request vr where status = "HOD APPROVAL PENDING"';
            const pendingRequestsforAdminResult = await this.vehiclerepo.query(pendingRequestsforAdminQuery);
            const pendingRequestsforHodResult = await this.vehiclerepo.query(pendingRequestsforHodQuery);
            let getTotalReq = "Select count(*) AS cnt from vehicle_request where DATE_FORMAT(vehicle_required_on, '%b') ='"+month+"'";
            const totalReq = await this.vehiclerepo.query(getTotalReq);
            // console.log(totalReq);
            let inhouseVehCountReq = "Select count(*) AS cnt from vehicle_request where DATE_FORMAT(vehicle_required_on, '%b') ='"+month+"' and vehicle_type = 'IN HOUSE' and vehicle_id IS NOT NULL";
            const totalInhouseCountRes = await this.vehiclerepo.query(inhouseVehCountReq);
            // console.log(totalInhouseCountRes);
            let VendorVehCountReq = "Select count(*) AS cnt from vehicle_request where DATE_FORMAT(vehicle_required_on, '%b') ='"+month+"' and vehicle_type = 'VENDOR' and vendor_id IS NOT NULL";
            const totalVendorCountRes = await this.vehiclerepo.query(VendorVehCountReq);
            // console.log(totalVendorCountRes);
            let inhousePercentage = ((Number(totalInhouseCountRes[0].cnt)/Number(totalReq[0].cnt))*100).toFixed(0);
            let vendorPercentage = ((Number(totalVendorCountRes[0].cnt)/Number(totalReq[0].cnt))*100).toFixed(0);
            // console.log(inhousePercentage);
            // console.log(vendorPercentage);
            let getTotalReqCuntReq = "Select count(*) AS cnt from vehicle_request where DATE_FORMAT(vehicle_required_on, '%b') ='"+month+"' and status NOT IN ('REJECTED')";
            const getTotalReqCuntRes = await this.vehiclerepo.query(getTotalReqCuntReq);
            let requestRatePerDay = (Number(getTotalReqCuntRes[0].cnt)/Number(daysInmonth)).toFixed(0);
            // console.log(requestRatePerDay);
            let getTotalRejCuntReq = "Select count(*) AS cnt from vehicle_request where DATE_FORMAT(vehicle_required_on, '%b') ='"+month+"' and status IN ('REJECTED')";
            const getTotalRejCuntRes = await this.vehiclerepo.query(getTotalRejCuntReq);
            let rejectionRatePerDay = (Number(getTotalRejCuntRes[0].cnt)/Number(daysInmonth)).toFixed(0);
            // console.log(requestRatePerDay);
            let getReqTimeAndApprovalTimeQuery = "Select pick_up_time AS pickUp, admin_approval_date AS adminApprove from vehicle_request where DATE_FORMAT(vehicle_required_on, '%b') ='"+month+"' and pick_up_time IS NOT NULL and admin_approval_date IS NOT NULL group by id";
            const getReqTimeAndApprovalTimeQueryRes = await this.vehiclerepo.query(getReqTimeAndApprovalTimeQuery);
            // console.log(getReqTimeAndApprovalTimeQueryRes);

            let totalDifference = 0;
            let count = getReqTimeAndApprovalTimeQueryRes.length;

            getReqTimeAndApprovalTimeQueryRes.forEach(request => {
                let requestedDate = new Date(request.pickUp);
                let approvalDate = new Date(request.adminApprove);
                let difference: number = approvalDate.getTime() - requestedDate.getTime(); // Difference in milliseconds
                totalDifference += difference;
            });

            let averageDifference = totalDifference / count; // Average difference in milliseconds
            // console.log(averageDifference);
            let totalSeconds = Math.floor(averageDifference / 1000);
            let hours = Math.floor(totalSeconds / 3600);
            let minutes = Math.floor((totalSeconds % 3600) / 60);
            let seconds = totalSeconds % 60;
            // console.log(`${hours} hours, ${minutes} minutes, ${seconds} seconds`);

            data.push({'HodApprovalPending':pendingRequestsforHodResult[0].cnt,'adminApprovalPending':pendingRequestsforAdminResult[0].cnt,'inhouseUtilization':inhousePercentage,'vendorUtilization':vendorPercentage,'requestRate':requestRatePerDay,'rejectionRate':rejectionRatePerDay,'avgApprovalRate':(hours>0?hours+'hrs':minutes>0?minutes+'Mins':seconds>0?seconds+'Sec':0)})
            if(data.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", data);
            }
            else {
                return new CommonResponseModel(false, 0, "No data found. ");
            }

        }catch (err) {
            throw err
        }
    }

    async getDepartmentWiseStatus(): Promise<CommonResponseModel> 
    {
        let data:any[] = [];
        try{
            let getDepData = "Select id,department_name AS department from department where is_active = true";
            const totalDeptData = await this.vehiclerepo.query(getDepData);
            for(const [index, res] of totalDeptData.entries()){
                // console.log(index)
                // console.log(res)

                let dept:any = {'department':''}
                dept.department = res?.department;
                for(const ress of Object.values(VehicleStatus)){
                    let statusWiseQuery = "Select count(*) AS cnt, '"+ress+"' AS status from vehicle_request where department_id = "+res.id+" and status = '"+ress+"'";
                    const statusData = await this.vehiclerepo.query(statusWiseQuery);
                    dept[`${ress}`] = statusData[0].cnt;
                    // dept.push(statusData)
                }
                // console.log(dept)
                data.push(dept);
            }
            if(data.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", data);
            }
            else {
                return new CommonResponseModel(false, 0, "No data found. ");
            }

        }catch (err) {
            console.log(err)
            throw err
        }
}

async getTop5TripDetailsOfDept(req:any): Promise<CommonResponseModel> {
    try{
        let query = "Select e.employee_name AS empName,sl.location_name AS source,dl.location_name AS destination, vehicle_required_on AS tripDate,d.name AS driver,vr.total_amount AS cost, vr.status from vehicle_request vr left join driver d on d.id = vr.driver_id left join locations sl on sl.id = vr.source left join locations dl on dl.id = vr.destination left join employee e on e.id = vr.employee_id where department_id = "+req.departmentId+" and vr.status IN ('VEHICLE ASSIGNED') order by vehicle_required_on ASC limit 5";
        const result = await this.vehiclerepo.query(query);
        if(result.length > 0){
            return new CommonResponseModel(true,1,"Data retrived successfully. ",result);
        }
        else{
            return new CommonResponseModel(false,0,"No data found. ");
        }
    }catch (err) {
        throw err
    }
}

async getScheduledTripsOnMonth(req:DatesDto): Promise<CommonResponseModel> {
    try{
        let fromDate = new Date(req.fromDate);
        let month = fromDate.toLocaleString('default', { month: 'short' })
        let query = "Select vehicle_required_on AS vehDate from vehicle_request where DATE_FORMAT(vehicle_required_on, '%b') ='"+month+"' and status IN ('VEHICLE ASSIGNED')";
        const result = await this.vehiclerepo.query(query);
        if(result.length > 0){
            return new CommonResponseModel(true,1,"Data retrived successfully. ",result);
        }
        else{
            return new CommonResponseModel(false,0,"No data found. ");
        }
    }catch (err) {
        throw err
    }
}

async getBudgetVSExpenditureDeptWise(): Promise<CommonResponseModel> 
    {
        let data:any[] = [];
        try{
            let getDepData = "Select id,department_name AS department from department where is_active = true";
            const totalDeptData = await this.vehiclerepo.query(getDepData);
            let budget:any[] = [];
            let expenditure:any[] = [];

            for(const res of totalDeptData){
                let query = "Select SUM(budget) AS budget from budget where departmentName = "+res.id;
                let result = await this.vehiclerepo.query(query);

                let expquery = "Select sum(total_amount) AS cost from vehicle_request where department_id = "+res.id+" and status = 'TRIP COMPLETED'";
                let expresult = await this.vehiclerepo.query(expquery);

                budget.push(result[0].budget);
                expenditure.push(expresult[0].cost);
            }
            data.push(budget)
            data.push(expenditure)

            if(data.length > 0){
                return new CommonResponseModel(true, 1, "Data Retrived. ", data,totalDeptData);
            }
            else {
                return new CommonResponseModel(false, 0, "No data found. ");
            }

        }catch (err) {
            console.log(err)
            throw err
        }
}
// async updateHodToApproved(): Promise<CommonResponseModel> 
//     {
//         try{
//             console.log("cron started")
//             let query = "SELECT GROUP_CONCAT(DISTINCT id) AS ids FROM vehicle_request WHERE STATUS = 'HOD APPROVAL PENDING' AND TIMESTAMPDIFF(MINUTE, created_at, NOW()) >= 30";
//             const result = await this.vehiclerepo.query(query);
//             console.log(result)
            
//             if(result.length > 0){
//                 let ids = result[0].ids.split(',').map(id => parseInt(id, 10));
//                 console.log(ids);
//                 let updateHodApprovalQuery = await this.vehiclereqRepo.update({id: In(ids)},{status:VehicleStatus.ADMIN_APPROVAL_PENDING});
//                 if(updateHodApprovalQuery.affected > 0){
//                     console.log(updateHodApprovalQuery)
//                     console.log("cron Ended")
                   
//                     let statusFlag
//                     for(const data of ids){
//                         let getDepartHeadNumber = "Select e.contact_number AS contact from vehicle_request v left join department d on d.id = v.department_id left join employee e on e.id = d.hod_id where v.id ="+data;
//                         const contact = await this.vehiclerepo.query(getDepartHeadNumber);
//                         const allData = await this.getAllDetailsofvehReq(data)
//                         let messageContent=`Vehicle Req Alert \\n Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} \\n Department : ${allData[0]?.departmentName?allData[0].departmentName:''} \\n Source :${allData[0]?.source?allData[0].source:' '} \\n Destination :${allData[0]?.destination?allData[0].destination:' '}\\n Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} \\n Vehicle Required On :${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} \\n Vehicle Requested On :${allData[0]?.requestedOn?moment(allData[0].requestedOn).format('YYYY-MM-DD'):' '} \\n User Name : ${allData[0].user?allData[0].user:' -'} \\n User Contact : ${allData[0].userContact?allData[0].userContact:' -'} \\n HOD approval time exceeded for request, forwarded to admin please validate. `
//                         const parameters = [
//                             { "type": "text", "text": moment().format('YYYY-MM-DD') },
//                             { "type": "text", "text": messageContent }, 
//                         ];
                    
//                   const  contactDetails =["7702255295","7702621117",contact[0].contact]

//                             for (const contact of contactDetails) {
//                                 const whatsappres = await new MessageParameters(contact, 'vrs_alert', parameters, 'en_us')
//                                 const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
//                                 if (!messageStatus.status) {
//                                     statusFlag = false
//                                     break

//                                 } else {
//                                     statusFlag = true
//                                 }

//                             }
//                     }

//                     return new CommonResponseModel(true, 1, "Updated successfully. ", result);
//                 }
//                 else{
//                     return new CommonResponseModel(false, 0, "Something went wrong. ");
//                 }
//             }
//             else {
//                 return new CommonResponseModel(false, 0, "No data found. ");
//             }

//         }catch (err) {
//             console.log(err)
//             throw err
//         }
// }

async updateHodAdminToApproved(): Promise<CommonResponseModel> 
    {
        try{
            // console.log("cron started")
            let query = "SELECT GROUP_CONCAT(DISTINCT id) AS ids FROM vehicle_request WHERE STATUS = 'HOD APPROVAL PENDING' AND TIMESTAMPDIFF(MINUTE, created_at, NOW()) >= 30";
            const result = await this.vehiclerepo.query(query);
            // console.log(result)
            
            if(result.length > 0){
                let ids = result[0].ids.split(',').map(id => parseInt(id, 10));
                // console.log(ids);
                let updateHodApprovalQuery = await this.vehiclereqRepo.update({id: In(ids)},{status:VehicleStatus.ADMIN_APPROVAL_PENDING});
                if(updateHodApprovalQuery.affected > 0){
                    // console.log(updateHodApprovalQuery)
                    //console.log("cron Ended")
                   
                    let statusFlag
                    for(const data of ids){
                        let getDepartHeadNumber = "Select e.contact_number AS contact from vehicle_request v left join department d on d.id = v.department_id left join employee e on e.id = d.hod_id where v.id ="+data;
                        let getDepartadminNumber = "SELECT e.contact_number AS admincontact FROM employee e JOIN roles r ON e.role = r.id WHERE r.role = 'HOD'"
                        const contact1 = await this.vehiclerepo.query(getDepartHeadNumber);
                        const contact2 = await this.vehiclerepo.query(getDepartadminNumber);
                        const contact = [...contact1, ...contact2];
                        const allData = await this.getAllDetailsofvehReq(data)
                        let messageContentforHOD=`Vehicle Req Alert || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source :${allData[0]?.source?allData[0].source:' '} || Destination :${allData[0]?.destination?allData[0].destination:' '}|| no of people : ${allData[0]?.noOfPeople?allData[0].noOfPeople:' '} || Vehicle Required On :${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Vehicle Requested On :${allData[0]?.requestedOn?moment(allData[0].requestedOn).format('YYYY-MM-DD'):' '}  || Pick up Time : ${allData[0]?.pickUpTime ? moment(allData[0].pickUpTime).format('HH:mm:ss') : ' '} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || HOD approval time exceeded for request, forwarded to admin for validation. `
                        let messageContentforAdmin=`Waiting for Admin approval- Vehicle Req Alert || Employee : ${allData[0].employeeName?allData[0].employeeName:' -'} || Department : ${allData[0]?.departmentName?allData[0].departmentName:''} || Source :${allData[0]?.source?allData[0].source:' '} || Destination :${allData[0]?.destination?allData[0].destination:' '}|| no of people : ${allData[0]?.noOfPeople?allData[0].noOfPeople:' '}  || Vehicle Required On :${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || Vehicle Requested On :${allData[0]?.requestedOn?moment(allData[0].requestedOn).format('YYYY-MM-DD'):' '}  || Pick up Time : ${allData[0]?.pickUpTime ? moment(allData[0].pickUpTime).format('HH:mm:ss') : ' '}  || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} || HOD approval time exceeded for request, forwarded to admin please validate. `
                        const parametersforHOD = [
                            { "type": "text", "text": moment().format('YYYY-MM-DD') },
                            { "type": "text", "text": messageContentforHOD }, 
                        ];
                        const parametersforAdmin = [
                            { "type": "text", "text": moment().format('YYYY-MM-DD') },
                            { "type": "text", "text": messageContentforAdmin }, 
                        ];
                    
                  const  contactDetailsforHOD =["917036716813","919900064294",contact[0].contact]
                  const  contactDetailsforAdmin =["917036716813","919900064294",contact[1].admincontact]
                  //console.log(contactDetails, "################################")

                            for (const contact of contactDetailsforHOD) {
                                const whatsappres = await new MessageParameters(contact, 'vrs_alert', parametersforHOD, 'en_us')
                                const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                                if (!messageStatus.status) {
                                    statusFlag = false
                                    break

                                } else {
                                    statusFlag = true
                                }

                            }
                            for (const contact of contactDetailsforAdmin) {
                                const whatsappres = await new MessageParameters(contact, 'vrs_alert', parametersforAdmin, 'en_us')
                                const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                                if (!messageStatus.status) {
                                    statusFlag = false
                                    break

                                } else {
                                    statusFlag = true
                                }

                            }
                    }

                    return new CommonResponseModel(true, 1, "Updated successfully. ", result);
                }
                else{
                    return new CommonResponseModel(false, 0, "Something went wrong. ");
                }
            }
            else {
                return new CommonResponseModel(false, 0, "No data found. ");
            }

        }catch (err) {
            console.log(err)
            throw err
        }
}

async getVehicleDetailsByReqId(req:VehicleReqId): Promise<CommonResponseModel> 
{
    // console.log(req);
    let query: any = await this.vehiclereqRepo.findOne({where:{id:req.reqId}});
    if(query.id > 0){
        let vehicleModel = "Select v.mark_model AS model from vehicle v where v.id ="+query.vehicleId;
        const data = await this.vehiclerepo.query(vehicleModel);
        query.markModel = data[0].model;
        return new CommonResponseModel(true,1,"Vehicle Req Details retrived. ",query);
    }
    else{
        return new CommonResponseModel(false,0,"No data found. ",);
    }
}

async getAllDetailsToUpdateDriver(req:DriverUpdateReq):Promise<CommonResponseModel>{
    try{
        // console.log(req,'requestttt')
        let query=`SELECT vehicle_name as vheiclename,vehicle_capacity as vehicleCapacity,v.vehicle_type as vehicleType,vehicle_req_code as vehicleReqCode,vn.vendor_name AS vendorName,d.name AS driverName,e.employee_name AS employeeName,v.id AS vehicleReqId,v.employee_id AS employeeId,v.vehicle_type AS vehicleType,v.status,v.driver_id AS driverId, v.vehicle_id AS vehicleId,v.driver_id AS driverId,v.vendor_id AS vendorId,sl.location_name as source,dl.location_name as destination,dp.department_name as department,e.contact_number as empContactNumber,v.vehicle_required_on as requestedOn,v.pick_up_time as pickUpTime
            FROM vehicle_request v 
            LEFT JOIN employee e ON e.id=v.employee_id
            LEFT JOIN driver d ON d.id=v.driver_id
            LEFT JOIN vendor vn ON vn.id=v.vendor_id
            left join vehicle vl on vl.id=v.vehicle_id
            left join locations sl on sl.id=v.source
            left join locations dl on dl.id=v.destination
            left join department dp on dp.id=v.department_id

            WHERE v.status='VEHICLE ASSIGNED'`
            if(req.role === "VrsAdmin"){
                query=query+` and v.vehicle_type IN('IN HOUSE')`
            }
            if(req.role === "VrsVendor"){
                // console.log('hiiiiii')
                const query2='SELECT id AS vendorId FROM vendor WHERE vendor_code IN("'+req.vendorCode+'")'
                const res=await this.vehiclereqRepo.query(query2)
                const vendorIds = res.map(item => item.vendorId).join(',');
                //   console.log(vendorIds); 
                // console.log(res,'ressss')
                query=query+`  and v.vehicle_type IN('VENDOR') and v.vendor_id in(${vendorIds})`
            }

            const result= await this.vehiclereqRepo.query(query)
            if(result){
                return new CommonResponseModel(true,1,'Data Retrived Sucessfully',result)
            }
            else{
                return new CommonResponseModel(false,0,'No Data Found',[])

            }
        }catch(err){
            throw err
        }
}
async getAllDriversToUpdate(req:DriverUpdateReq):Promise<CommonResponseModel>{
    try{
        let query=`SELECT id AS driverId,d.name AS driverName,driver_type AS driverType,vendor_id AS vendorId,phone_number as driverContactNum
                    FROM driver d  WHERE d.id NOT IN(${req.driverId})`
                    if(req.role === "VrsAdmin"){
                        query=query+` and driver_type IN('IN HOUSE')`
                    }  
                    if(req.role === "VrsVendor"){
                        query=query+`  and  driver_type IN('VENDOR')`
                    }
                    const result= await this.vehiclereqRepo.query(query)
            if(result){
                return new CommonResponseModel(true,1,'Data Retrived Sucessfully',result)
            }  else{
                return new CommonResponseModel(false,0,'No Data Found',[])

            }

    }catch(err){
        throw err
    }
}

async updateDriver(req:DriverUpdateReq):Promise<CommonResponseModel>{
    try{  
       const update=await this.vehiclereqRepo.update({id:req.vehicleReqId},{driverId:req.driverId})
       if(update.affected){
        
        let phnNumber=req.driverContactNumber?req.driverContactNumber:'919502201959'
        if(phnNumber.length === 12){
            phnNumber=phnNumber
        }else{
            phnNumber='91'+phnNumber
        }

        let messageContent=`Dear ${req.driverName} || You Got The Ride  || PickUp Location : ${req.source?req.source:''}  || Destination : ${req?.destination?req.destination:' '}|| PickUp Time : ${req.pickUpTime?moment(req.pickUpTime).format('YYYY-MM-DD HH:MM'):' '} || Requested By : ${req.employee?req.employee:''} || Contact : ${req.employeeContactNumber?req.employeeContactNumber:''}  || Please Contact Requested Person to Reach Location || Thank You`

        const parameters = [
            { "type": "text", "text": moment().format('YYYY-MM-DD') },
            { "type": "text", "text": messageContent }, 
        ];
     
    //    console.log(parameters,'parametersssssss')
    //    console.log(phnNumber,'phone numberrrr')
       let statusFlag
       const whatsappres = await new MessageParameters(phnNumber, 'vrs_alert', parameters, 'en_us')
       const messageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
    //    console.log(messageStatus,'mesaage statussss')
       if (!messageStatus.status) {
           statusFlag = false
        //    break

       } else {
           statusFlag = true
       }


        return new CommonResponseModel(true,1,'Driver Updated Sucessfully')
       }else{
        return new CommonResponseModel(false,0,'Something Went Wrong')
       }

    }catch(err){
        throw err
    }

}

async assignRequestToVendor(req:AssignVendor):Promise<CommonResponseModel>{
    try{
        let updateVendor = await this.vehiclereqRepo.update({id :In(req.vehicleReqIds)},{vendorId:req.vendorId,vehicleType:VehicletypeEnum.VENDOR_VEHICLE,status:VehicleStatus.WAITING_ON_VENDOR,adminApprovalDate:req.approvalDate});
        if(updateVendor){
            const query = 'select contact_number as contactNum from employee where employee_name = "MRUTHUNJAYA.S"'
                const adminNum = await this.vehiclereqRepo.query(query)
                let msg
                let messageContent
                let contactDetails
                let vendortotalMsg = `Admin Assigned To Vendor || `;
                let admintotalMsg = `Assigned Requests to Vendor || `;
                let emptotalMsg = `Request Assigned to vendor || `;
                for(const rs of req.vehicleReqIds){
                    // console.log(rs);
                    const allData = await this.getAllDetailsofvehReq(rs)
                    // console.log(allData);

                    msg='Note : New Requests Arrived Please Assign Vehicle '
                    messageContent=`Source : ${allData[0]?.source?allData[0].source:' '} || Destination : ${allData[0]?.destination?allData[0].destination:' '}|| Vehicle Type : ${allData[0].vehicleType?allData[0].vehicleType:' '} || Vehicle Capacity : ${allData[0]?.vehicleCapacity?allData[0].vehicleCapacity:' '} || Vehicle Required On : ${allData[0]?.vehicleReqOn?moment(allData[0].vehicleReqOn).format('YYYY-MM-DD'):' '} || User Name : ${allData[0].user?allData[0].user:' -'} || User Contact : ${allData[0].userContact?allData[0].userContact:' -'} ||`

                    contactDetails =["917036716813","919900064294",allData[0]?.hodContactNum,allData[0]?.empContactNumber,adminNum[0]?.contactNum,allData[0]?.vendorPhoneNumber]
                    
                    vendortotalMsg = vendortotalMsg + messageContent;
                    admintotalMsg = admintotalMsg + messageContent;
                    emptotalMsg = emptotalMsg + messageContent;


                   
                    const empparameters = [
                        { "type": "text", "text": moment().format('YYYY-MM-DD') },
                        { "type": "text", "text": emptotalMsg }, 
                    ];

                    for(const contact of contactDetails){
                    const whatsappres = await new MessageParameters(contact, 'vrs_alert', empparameters, 'en_us')
                    const empMessageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                    }
                    
                    for(const contact of contactDetails){
                    const hodwhatsappres = await new MessageParameters(contact, 'vrs_alert', empparameters, 'en_us')
                    const hodempMessageStatus = await this.whatsAppService.sendMessageThroughFbApi(hodwhatsappres);
                    }
                    
                    
                }

                const adminparameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": admintotalMsg }, 
                ];
                
                const vendorparameters = [
                    { "type": "text", "text": moment().format('YYYY-MM-DD') },
                    { "type": "text", "text": vendortotalMsg+ msg }, 
                ];
                for(const contact of contactDetails){
                const whatsappres = await new MessageParameters(contact, 'vrs_alert', vendorparameters, 'en_us')
                const vendorMessageStatus = await this.whatsAppService.sendMessageThroughFbApi(whatsappres);
                }
                for(const contact of contactDetails){
                const adminwhatsappres = await new MessageParameters(contact, 'vrs_alert', adminparameters, 'en_us')
                const adminMessageStatus = await this.whatsAppService.sendMessageThroughFbApi(adminwhatsappres);
                }
               
                return new CommonResponseModel(true,1,'Admin Approved Sucessfully',)
        }
        else{
            return new CommonResponseModel(false,0,"Somthing Went Wrong. ")
        }
    }catch(err){
        throw err
    }
}

async forwardVehicleRequestToHod(userResponse) {
    // console.log(userResponse);
    const BEARRER_TOKEN = "EAAPlWQYnjvkBO3nJuYbGL6Afc6AKwCt3wz4vp4LD6XSMAWwQkgOeCaDcObuHzbkW4z8QSXUZCO1CvMzVCZBTAtpTZA0sIinwZCPcKBiZCQf4YukEAQ9LB5a6ofpQO4oSmGbBZCzRq2T2GRPYZCo3BAguGhmv9NfrZAaFOZByNUVjoVRExpG2SgROsinlVIM5FJzqUehtG3QfjHeLW7MXM";
    try {
        // const hodDetailsRes = await this.employeeService.getHodDetailsByEmp({ contactNumber: userNumber.substring(2) })
        const approveRejectMessagePayload = {
            "messaging_product": "whatsapp",
            "recipient_type": "individual",
            "to": userResponse[0].hodContactNum,
            "type": "interactive",
            "interactive": {
                "type": "button",
                "header": {
                    "type": "text",
                    "text": "Vehicle request"
                },
                "body": {
                    "text": `Dear ${userResponse[0].headOfThedeprt} \n\n ${userResponse[0].employeeName} is requsted for your approval. \n Would appreciate if you could approve \n\n Requested Date : ${moment(Number(userResponse[0]?.vehicleReqOn)).format("DD-MM-YYYY")} \n No of People : ${userResponse[0].noOfPeople}  \n Vehicle prefrence : ${userResponse[0].vehiclePreference} \n Purpose : ${userResponse[0].vehiclePurpose} \n Pick-up Point : ${userResponse[0].source} \n Drop point :  ${userResponse[0].destination}}`
                },
                "footer": {
                    "text": ""
                },
                "action": {
                    "buttons": [
                        {
                            "type": "reply",
                            "reply": {
                                "id": `${userResponse[0].vehiclereqId}-A`, // vehicle request id
                                "title": "Approve"
                            }
                        },
                        {
                            "type": "reply",
                            "reply": {
                                "id": `${userResponse[0].vehiclereqId}-R`, // vehicle request id
                                "title": "Reject"
                            }
                        }
                    ]
                }
            }
        }
       await axios.post(
            `https://graph.facebook.com/v19.0/437711296082941/messages`,
            approveRejectMessagePayload,
            {
                headers: {
                    Authorization: `Bearer ${BEARRER_TOKEN}`,
                },
            },
        );
    } catch (error) {
        console.error('Error sending forwardVehicleRequestToHod', error);
    }
}

}